import React from "react";
import "../style.css";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";

const CardTotal = ({
  amount,
  isTax,
  totalTax,
  totalTaxable
}) => {

  /**
   * Quando si è in creazione la card cambia leggermente
   */
  return (
    <div className="pre-cog-detail-header-total-card">
      <div style={{ padding: 16, borderBottom: "1px solid #c9d9e8" }}>
        <div className="pre-cog-detail-header-total-title"
        >
          <FormattedMessage id={ "preCog.header.docTotal"} />
        </div>
        <div className="pre-cog-detail-header-total-amount"
          style={(!amount || numeral(Math.abs(amount)) === 0) ? {color: "#9da6ad"} : {}}
        >
          {numeral(Math.abs(amount)).format("0,0.00")} €
        </div>
      </div>
      {  
        isTax &&
      <div style={{ padding: 16 }}>
        <div className="pre-cog-detail-header-taxable">
          <div className="pre-cog-detail-header-taxable-text">
            <FormattedMessage id="preCog.header.taxable" />
          </div>
          <div className="pre-cog-detail-header-taxable-amount">
            {totalTaxable ? numeral(Math.abs(totalTaxable)).format("0,0.00") : "0,00"} €
          </div>
        </div>

        <div className="pre-cog-detail-header-taxable">
          <div className="pre-cog-detail-header-taxable-text">
            <FormattedMessage id="preCog.header.tax" />
          </div>
          <div className="pre-cog-detail-header-taxable-amount">
            {totalTax ? numeral(Math.abs(totalTax)).format("0,0.00") : "0,00"} €
          </div>
        </div>
      </div>
      }
    </div>
  );
};

export default CardTotal;
